import angular from 'angular';

function isObject(obj) {
  return obj === Object(obj);
}

const Storage = angular.module('storage', [])
  .service('storage', function () {

    this.setItem = (storageType, key, value) => {
      try {
        if (value !== undefined) {
          if (storageType === 'local') {
            localStorage.setItem(key, JSON.stringify(value));
          }
          else if (storageType === 'session') {
            sessionStorage.setItem(key, JSON.stringify(value));
          }
        }
      }
      catch (e) {
        return undefined;
      }
    };

    this.getItem = (storageType, key) => {
      var value;
      try {
        if (storageType === 'local') {
          value = localStorage.getItem(key);
        }
        else if (storageType === 'session') {
          value = sessionStorage.getItem(key);
        }
        return value ? JSON.parse(value) : null;
      } catch (e) {
        return undefined;
      }
    };

  });

export default Storage;



// WEBPACK FOOTER //
// ./client/app/storage/storage.js